<template>
  <v-container>
    <h1 class="mb-2">{{$t('admin.alerts.alerts')}}</h1>
    <custom-text msg="custom-text.alerts" class="mt-2 mb-1"></custom-text>
    <v-flex pt-2>
      <v-btn id="create-alert-btn" aria-label="create-new-alert" color="primary" class="primary-text" @click="createAlert">
        {{$t('admin.alerts.new.create_new')}}
      </v-btn>
    </v-flex>
    <v-list class="py-0 mt-2">
      <v-progress-linear v-if="alertsLoading" height="2" :indeterminate="true" color="accent"></v-progress-linear>

      <alert-table-row  v-for="(alert, key) in alerts" :key="key" :alert="alert" v-if="!alert.isHidden" :alert-key="key"/>

      <div v-if="noAlerts && !alertsLoading" :style="noAlertsContainer" class="no-data">
        <span :style="noAlertsText">{{$t('admin.alerts.new.no_data')}}</span>
      </div>
    </v-list>
  </v-container>
</template>

<script>
  import CustomText from '../../help/CustomText'
  import AlertTableRow from './AlertTableRow'
  import { GET_ALERTS_LANDING } from '../../../store/action-types'
  import { getTextColor } from '../../../HelperMethods'
  import { RESET_SINGLE_ALERT, CREATE_NEW_DEFAULT_ALERT, ALERT_DETAILS_PANEL_DISPLAY_FLAG } from '../../../store/mutation-types'

  export default {
    name: 'alerts-landing',
    components: {AlertTableRow, CustomText},
    data () {
      return {
        noStudentsColor: this.$vuetify.theme.info
      }
    },
    methods: {
      getTextColor (value) {
        return getTextColor(value)
      },
      createAlert () {
        this.$store.commit(ALERT_DETAILS_PANEL_DISPLAY_FLAG, false)
        this.$store.commit(CREATE_NEW_DEFAULT_ALERT)
        this.$router.push({name: 'AlertDetails', params: {id: 0}})
      }
    },
    computed: {
      alerts () {
        return this.$store.state.admin.newAlerts
      },
      alertsLength () {
        return Object.keys(this.alerts).length
      },
      noAlerts () {
        return Object.keys(this.$store.state.admin.newAlerts.filter(el => !el.isHidden)).length === 0
      },
      noAlertsText () {
        return { color: getTextColor(this.noStudentsColor) }
      },
      noAlertsContainer () {
        return { backgroundColor: this.noStudentsColor }
      },
      alertsLoading () {
        return this.$store.state.admin.landingAlertsLoading
      }
    },
    mounted () {
      this.$store.commit(RESET_SINGLE_ALERT)
      this.$store.commit(ALERT_DETAILS_PANEL_DISPLAY_FLAG, true)
      if (this.alertsLength <= 0) {
        this.$store.dispatch(GET_ALERTS_LANDING)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertsLanding.vue